import React, {useEffect, useRef} from "react";
import {dataStorage} from "../../utils/StorageService";
import {useSoundToggle} from "../useSoundToggle";
import {DragItemType, GridItemType} from "../../types";

interface Props {
    score: number;
    gridData: GridItemType[][];
    dragItems: DragItemType[]
    setIdeaProcessing: React.Dispatch<React.SetStateAction<boolean>>
}

/***
 * Сохраняем данные при изменении счета!
 * */
export const useSaveDataScoreChanged = ({score, gridData, dragItems, setIdeaProcessing}: Props) => {
    const {playSound} = useSoundToggle('paste_cube');
    const timer = useRef<NodeJS.Timeout>();

    useEffect(() => {
        if (timer.current) {
            clearTimeout(timer.current)
        }

        timer.current = setTimeout(() => {
            const payload = {
                score_data: score,
                grid_data: gridData,
                tools_panel: dragItems,
            };
            dataStorage.setItem(payload);
        }, 2000)
        playSound();

        // выключаем подсказку при вставке фигуры на поле
        setIdeaProcessing(false);
    }, [score])
}
